/* eslint-disable react/require-default-props */
import * as React from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

const PhoneIMask = React.forwardRef(({ onChange, name = '', ...other }, ref) => {
  return (
    <IMaskInput
      mask="(#00) 000-0000"
      definitions={{ '#': /[1-9]/ }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name, value } })}
      overwrite
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
    />
  );
});

PhoneIMask.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export { PhoneIMask };